<template>
    <section class="content">
      <div>
        <div id="overlay" v-if="loading">
          <div class="spinner"></div>
          <br/>
          <h4>Loading...</h4>
        </div>
        <div class="box box-info">
          <form>
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-1 p-mt-5">
                <Button @click.prevent="searchReport"
                        class="p-button-raised" label="Search" icon="pi pi-search"/>
              </div>
            </div>
          </form>
              <DataTable :value="salesPaidCollectionLists"
                         ref="po"
                         :rowsPerPageOptions="[100,500,1000]" :paginator="true" :rows="100" 
                         :filters="filters"
                         exportFilename="salesPaidCollection"
                         class="p-datatable-responsive p-datatable-gridlines"
                         data-key="id">
                         <template #header>
              <div style="text-align: left">
                <Button icon="pi pi-external-link" label="Export" @click="exportCSV($event)" />
              </div>
            </template>
                <Column header="S.N">
                  <template #body="sl">
                    {{sl.index+1}}
                  </template>
                </Column>
                <Column header="Month" :sortable="true" field="accountName" filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['accountName']"/>
                  </template>
                </Column>
                <Column header="Sales" :sortable="true" field="m4Sales" filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['m4Sales']"/>
                  </template>
                </Column>
                <Column header="Paid" :sortable="true" field="m4Paid" filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['m4Paid']"/>
                  </template>
                </Column>
                <Column header="Due" :sortable="true" field="m4Due" filterMatchMode="contains">
                  <template #filter>
                    <InputText type="text" class="p-column-filter" v-model="filters['m4Due']"/>
                  </template>
                </Column>
                <template #empty>No record found</template>
              </DataTable>
        </div>
      </div>
    </section>
  </template>
  <script>
  import DatePicker from 'vue2-datepicker'
  import DataTable from 'primevue/datatable'
  import Column from 'primevue/column'
  import $ from 'jquery'
  import InputText from 'primevue/inputtext'
  import InputMask from 'primevue/inputmask'
  import Button from 'primevue/button'
  export default {
    name: 'salesPaidCollectionLists',
    data() {
      return {
        fromDate: null,
        toDate: null,
        warehouse: '',
        warehouseId: '',
        formatted_date: '',
        salesPaidCollectionLists: [],
        loading: false,
        columnList: '',
        id: '0',
        filters: {},
        englishDateEnabled: true,
        setWarehouseData: false
      }
    },
    mounted() {
      this.checkEnglish()
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.nepaliDate()
      }
      if (!this.$store.getters.englishDate && this.salesChallan === undefined ||
        this.$store.state.isEnglishDateEnabled === 'false') {
        this.setNepaliDate()
      }
      if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
        this.setEnglishDate()
      }
      this.columnNames()
      this.setWarehouse()
    },
    methods: {
      async searchReport() {
        this.loading = true
        let resp = await this.$store.dispatch('loadSalesPaidCollectionReport', 'overAllCollection')
        this.loading = false
        this.salesPaidCollectionLists = resp
      },
      exportCSV() {
        this.$refs.po.exportCSV()
      },
      columnNames() {
        for (let i = 0; i < this.$refs.po.columns.length; i++) {
          this.columnList += this.$refs.po.columns[i].header + ','
        }
      },
      reset() {
        this.salesPaidCollectionLists = []
        if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
          this.fromDate = this.$store.getters.nepaliNewDate
          this.toDate = this.$store.getters.nepaliNewDate
        } else {
          this.fromDate = new Date().toISOString().slice(0, 10)
          this.toDate = new Date().toISOString().slice(0, 10)
        }
      },
      setNepaliDate() {
        if (this.$store.getters.nepaliNewDate !== '') {
          this.fromDate = this.$store.getters.nepaliNewDate
          this.toDate = this.$store.getters.nepaliNewDate
        }
      },
      setEnglishDate() {
        this.fromDate = new Date().toISOString().slice(0, 10)
        this.toDate = new Date().toISOString().slice(0, 10)
      },
      checkEnglish() {
        if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
          this.englishDateEnabled = true
          return
        } else {
          this.englishDateEnabled = false
          return
        }
      },
      nepaliDate() {
        $('#fromDate').nepaliDatePicker({
          ndpYear: true,
          ndpMonth: true,
          ndpYearCount: 10,
          disableBefore: this.$store.state.startDate,
          disableAfter: this.$store.state.endDate,
          onChange: () => {
            this.fromDate = $('#fromDate').val()
          }
        })
        $('#toDate').nepaliDatePicker({
          ndpYear: true,
          ndpMonth: true,
          ndpYearCount: 10,
          disableBefore: this.$store.state.startDate,
          disableAfter: this.$store.state.endDate,
          onChange: () => {
            this.toDate = $('#toDate').val()
          }
        })
      }
    },
    components: {
      DatePicker,
      DataTable,
      Column,
      InputText,
      InputMask,
      Button
    }
  }
  </script>
  <style scoped src="@../../../static/css/purchase.css">
  
  </style>



// WEBPACK FOOTER //
// paymentDueAnalysis.vue?6fb6b340